export const COUNTRY_CODES = [
  {
    label: 'USA',
    value: 'US',
  },
  {
    label: 'Canada',
    value: 'CA',
  },
  {
    label: 'Mexico',
    value: 'MEX',
  },
];
